/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ScienceClubSideBar from 'views/ScienceClubSideBar/ScienceClubSideBar';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Grid from '@mui/material/Grid';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// // import Divider from '@mui/material/Divider';
// import Avatar from '@mui/material/Avatar';
// import IconButton from '@mui/material/IconButton';
// import FacebookIcon from '@mui/icons-material/Facebook';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import InstagramIcon from '@mui/icons-material/Instagram';

const Form = () => {
  const theme = useTheme();
 
  // const photos = [
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img25.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img22.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img24.jpg',
  //     rows: 1,
  //     cols: 1,
  //   },
  //   {
  //     src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
  //     rows: 1,
  //     cols: 2,
  //   },
  // ];

  return (
    <Box>
      <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
        <Typography variant='h5' align='center'>
        Workshop on “First aid and basic life support”
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        <br/>Department of Biology, National Public School, Yeshwanthpur organised a workshop on “First Aid and Basic Life Support” conducted by Manipal Hospitals Yeshwanthpur for students of class 10.

<br/>Dr. Supraja Chandrashekhar and Dr. Gurudutt gave an effective demonstration on CPR technique and other life-saving skills which could be implemented practically on individuals suffering from choking, animal bites, allergies, etc.

<br/>Students were given practice to perform CPR on the medical mannequins brought by the Manipal team. It was an interactive and educative session which will enable our students to face any untoward situation in life without panic and to display their skills confidently.
        </Typography>
        <Typography align='center' fontWeight={500}>
        HIGHLIGHTS OF THE SESSION
        </Typography>

        
      </Box>
    </Box>
  );
};

export default Form;
